import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import * as de from './locales/translations/de.json';
import * as en from './locales/translations/en.json';
import * as es from './locales/translations/es.json';
import * as fr from './locales/translations/fr.json';
import * as it from './locales/translations/it.json';
import * as pt from './locales/translations/pt.json';
import * as fi from './locales/translations/fi.json';
import * as gr from './locales/translations/gr.json';
import * as pl from './locales/translations/pl.json';
import * as ro from './locales/translations/ro.json';
import * as hr from './locales/translations/hr.json';

const resources = {
    en,
    de,
    es,
    fr,
    it,
    pt,
    fi,
    gr,
    pl,
    ro,
    hr,
};

i18n.use(initReactI18next).init({
    ns: ['commons', 'dataentry', 'veterinaryanalysis', 'missing_info'],
    defaultNS: 'commons',
    resources,
    lng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
